import { useAuth } from '#wa/composables/useAuth'

/**
 * Loads the useAuth as a global available on $auth to ensure authed user is loaded
 * before rendering
 */
export const authPlugin = defineNuxtPlugin({
  name: 'authPlugin',
  dependsOn: ['pinia', 'axiosPlugin', 'vuexLoader'], //<- important, ensures these plugins load before this one
  setup(nuxtApp) {
    const authStore = useAuth()
    nuxtApp.provide('auth', authStore)

    addRouteMiddleware(
      'auth-route-middleware',
      async (to, from) => {
        await authStore.loadUser()
      },
      {
        global: true,
      },
    )
  },
})

export default authPlugin
